
export async function GetVMdDept({setDeptsData, setLoading}) {
      setLoading(true)
      try{
            const responseDept = await fetch("/api/MasterData/getVMdDept")
            const data = await responseDept.json()
            // console.log(Deptdata);
            setDeptsData(data.dataenum.map((item) => ({
            value:item.deptId,
            label:item.site
            })))
      } catch (e) {
            console.log(e)
      } finally {
            setLoading(false);
      }
}

export async function GetTitleName({setTitleName, setLoading}) {
      setLoading(true)
      try{
            const res = await fetch("/api/MasterData/getTitle")
            const data = await res.json()
            setTitleName(data.dataenum);
      } catch(e) {
            console.log(e)
      } finally {
            setLoading(false)
      }
}

 // ดึง master data จังหวัด
export async function GetProvince({setLocationProvince, setLoading}) {
      setLoading(true)
      try{
            const responseProvince = await fetch("/api/MasterData/getProvince")
            const localtionData = await responseProvince.json()
            setLocationProvince(localtionData.dataenum)     
      } catch (e) {
            console.log(e)
      } finally {
            setLoading(false)
      }
      
}


export async function GetCurProvince({setLocationCurProvince, setLoading}) {
      setLoading(true)
      try{
            const responseProvince = await fetch("/api/MasterData/getProvince");
            const localtionData = await responseProvince.json();
            setLocationCurProvince(localtionData.dataenum);
      } catch (e) {
            console.log(e)
      } finally {
            setLoading(false)
      }    
}

export async function GetIndustrial({setIndustrialData, setLoading}) {
      setLoading(true)
      try{
            const res = await fetch("/api/MasterData/getIndustrial");
      const industrialData = await res.json();
      setIndustrialData(industrialData.dataenum);
      } catch (e) {
            console.log(e)
      } finally {
            setLoading(false)
      }
      

};